import React from 'react';
// import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ isLogin, children }) => {
  const issLogin = JSON.parse(localStorage.getItem('isLogin'));

  if (!issLogin) {
    return <Navigate to='/' replace />;
  }

  return children;
};

export default ProtectedRoute;
